import React from 'react';
import './footer.scss';

export default function Footer({ ...rest }) {
  const year = new Date().getFullYear();

  return (
    <footer className={'footer'} {...rest}>
      © {year} JD Tech. All rights reserved.
      <br />
      All trademarks and registered trademarks are the
      property of their respective owners.
    </footer>
  );
}
